import './bugsnag'

const LOADER_FIX_APPLICATION_BOOTSTRAP_DELAY = 250

setTimeout(() => {
  import(/* webpackChunkName: "index" */ './index').then(module =>
    module.bootstrap(),
  )
}, LOADER_FIX_APPLICATION_BOOTSTRAP_DELAY)
